// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2VUQ1","upload":"Small_upload__2FfjG","imageWrap":"Small_imageWrap__gkeap","removeBtn":"Small_removeBtn__3qmWO"};